import { chooseTemplate } from "../../utils/builder/IScheduleLogic";
import { parseTemplateSettingsDto, transformCustomColumnsDtoToData, updateFilters } from "../../utils/helpers";
import {UPDATE_FILTER, RESET_TABLE, RESET, UPDATE_STATS, SET_QUICK_INFO_COMPARE} from "../constans";
import { updateTable } from "./table";
import { logError } from "../../utils/builder/IAmecLog";
import { loadTabSettingsAC } from "./tabsSettings";
import { updateFilterTable } from "./templateSettings";
import { addTranslationsToState } from "./translations";

export const updateFilter = (callBack, type) => async (dispatch) => {
  try {
    const res = await callBack();
    const data = updateFilters(res); //just deep copy of res

    dispatch({
      type: type,
      payload: data,
    });
    
    if (data.translations && data.translations.length > 0) {
      dispatch(addTranslationsToState(data.translations))
    }
  } catch (err) {
    logError("FrontEnd.src.store.actions.filter.updateFilter", err.toString());
  }
};

export const clearSelectionState = (data) => async (dispatch) => {
  try {
    const dataCopy = updateFilters(data);  //just deep copy of res

    dispatch({
      type: UPDATE_FILTER,
      payload: dataCopy,
    });

    dispatch({
      type: RESET_TABLE,
    });
  } catch (err) {
    logError("FrontEnd.src.store.actions.filter.clearSelectionState", err.toString());
  }
};

export const setTemplateAction = (templateName, templateFolder) => async (dispatch) => {

    try {
        if (templateFolder != null) {
            await dispatch({ type: RESET, payload: templateName });

            const res = await chooseTemplate(templateName, templateFolder);
            if (res.translations) {
              dispatch(addTranslationsToState(res.translations))
            }

            const columnSchemes = transformCustomColumnsDtoToData(res.customColumns)
            const colorScheme = res.colorScheme

            const newTemplateSettings = await parseTemplateSettingsDto(res.settings)

            res.settings = newTemplateSettings

            dispatch(loadTabSettingsAC({
              currentTableId: 1,
              columnSchemes,
              colorScheme,
            }))
            dispatch(updateTable(res.settings.properties, res.settings.groups));

            const data = updateFilters(res);  //just deep copy of res

            dispatch({
                type: UPDATE_FILTER,
                payload: data,
            });

            dispatch(updateFilterTable())
        }
  } catch (err) {
    logError("FrontEnd.src.store.actions.filter.setTemplateAction", err.toString());
  }
};

export const doubleClickCallback = (res) => (dispatch) => {
  const data = updateFilters(res);

  dispatch({
    type: UPDATE_FILTER,
    payload: data,
  });
};

export const onSelectionChange = (quickCounterData) => (dispatch) => {

  try {
    dispatch({
      type: UPDATE_STATS,
      payload: quickCounterData,
    });
  } catch (err) {
    logError("FrontEnd.src.store.actions.filter.onSelectionChange", err.toString());
  }
}

export const setQuickInfoCompare = (res)  => {

  return {
    type: SET_QUICK_INFO_COMPARE,
    payload: res,
  };
}
